import React from 'react';
import { motion } from 'framer-motion';
import { Button, WHATSAPP_URL } from './ui/Button';
export function CtaBanner() {
  return <section className="relative py-32 overflow-hidden" data-id="element-65">
      {/* Background Image with Parallax effect */}
      <div className="absolute inset-0 z-0" data-id="element-66">
        <img src="https://images.unsplash.com/photo-1519824145371-29681b328e64?q=80&w=2070&auto=format&fit=crop" alt="Spa background" className="w-full h-full object-cover object-center" data-id="element-67" />
        <div className="absolute inset-0 bg-deepblack/60 backdrop-blur-[2px]" data-id="element-68"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-70">
          <h2 className="text-5xl md:text-7xl font-serif text-white mb-8 text-balance" data-id="element-71">
            Tu transformación{' '}
            <span className="italic font-light text-rosegold" data-id="element-72">empieza hoy</span>
          </h2>
          <p className="text-xl text-white/80 font-sans font-light mb-12 max-w-xl mx-auto" data-id="element-73">
            Da el primer paso hacia tu mejor versión. Nuestro equipo de
            especialistas está listo para asesorarte.
          </p>
          <Button href={WHATSAPP_URL} size="lg" className="shadow-2xl shadow-rosegold/20" data-id="element-74">
            Reservar mi turno ahora
          </Button>
        </motion.div>
      </div>
    </section>;
}